/**
 * @description 工具函数
 */
import config from '../config/'

export function timeString(date) {
  var now = date ? new Date(date) : new Date()
  return now.getUTCFullYear() + [now.getMonth() + 1, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds()].map(function (item) {
    return item < 10 ? '0' + item : item
  }).join('')
}

export function timeStringArr(bubble) {
  const now = new Date()
  const year = now.getUTCFullYear()
  const _month = now.getMonth() + 1
  const _date = now.getDate()
  const _hour = now.getHours()
  const _minute = now.getMinutes()
  const _second = now.getSeconds()
  const format = item => item < 10 ? '0' + item : item
  const [month, date, hour, minute, second] = [_month, _date, _hour, _minute, _second].map(format)
  if (bubble) {
    return [
      `${year}-${month}-${date} ${hour}:${minute}:${second}`,
      year + [month, date, hour, minute, _second].join('')
    ]
  }
  return year + [month, date, hour, minute, _second].join('')
}

/**
 * @description 复制
 */
export function clone(origin) {
  let originProto = Object.getPrototypeOf(origin)
  return Object.assign(Object.create(originProto), origin)
}

/**
 * @description 是否为对象
 */

export function isObject(obj) {
  let bool = false
  for (let prop in obj) {
    if (prop) {
      bool = true
    }
    break
  }
  return bool
}

export function setSessionCache(key, value) {
  window.sessionStorage.setItem(key, JSON.stringify(value))
}

export function getSessionCache(key) {
  const cache = window.sessionStorage.getItem(key)
  return cache ? JSON.parse(cache) : null
}

export function setStorageCache(key, value) {
  window.localStorage.setItem(key, JSON.stringify(value))
}

export function clearUserInfo() { // 清空用户登录信息
  window.localStorage.removeItem(`cacheUser`)
}

export function getStorageCache(key) {
  const cache = window.localStorage.getItem(key)
  return cache ? JSON.parse(cache) : null
}

export function getSingleTone(fn) {
  let instance
  return function () {
    return instance || (instance = fn.apply(this, arguments))
  }
}

export function sortWithKey(list, key) {
  return list.sort((a, b) => {
    let x = a[key]
    let y = b[key]
    return (x < y) ? -1 : ((x > y) ? 1 : 0)
  })
}

/** 判断是否为微信浏览器环境内部 */
export function isInWechat() {
  return /micromessenger/.test(navigator.userAgent.toLowerCase())
}

/** 判断是否在支付宝环境内 */
export function isInAlipay() {
  return /alipayclient/.test(navigator.userAgent.toLocaleLowerCase())
}

// 排序
export function sortKey(list, key) {
  return list.sort((a, b) => {
    let x = a[key]
    let y = b[key]
    return (x < y) ? -1 : ((x > y) ? 1 : 0)
  })
}

// IOS客户端
export function isIOS() {
  return /i(phone|pad|os)/g.test(navigator.userAgent.toLowerCase())
}

// ANDROID 客户端
export function isAndroid() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1
}

// 获取URL参数
export function getUrlParam(key) {
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  return r != null ? unescape(r[2]) : ''
}
export function getUrlHash(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let str = window.location.hash.split('?')[1]
  let r = str ? str.match(reg) : null
  if (r != null) return (r[2])
}
export function removeStorageInfo(key) {
  window.localStorage.removeItem(key)
}

export const getDate = (date, isYMS) => {
  date = date ? new Date(date) : new Date()
  let val1 = [date.getFullYear(), date.getMonth() + 1, date.getDate()].map(function (item) {
    return item < 10 ? '0' + item : item
  }).join('-')
  if (isYMS) { // 需要时分秒
    return `${val1} ` + [date.getHours(), date.getMinutes(), date.getSeconds()].map(function (item) {
      return item < 10 ? '0' + item : item
    }).join(':')
  }
  return val1
}

/**
 * 时间跨度
 */
export const getMonthBefor = (num, time) => {
  let year, month, date, currDate
  if (time) {
    time = parseInt(time)
    currDate = new Date(time)
  } else {
    currDate = new Date()
  }
  year = currDate.getFullYear()
  month = currDate.getMonth() + 1
  date = currDate.getDate()
  if (num) {
    if (num === 1) {
      switch (month) {
        case 1:
          month += 11
          year--
          break
        default:
          month -= 1
          break
      }
    } else if (num === 2) {
      switch (month) {
        case 1:
        case 2:
          month += 10
          year--
          break
        default:
          month -= 2
          break
      }
    }
  } else { // 3个月
    switch (month) {
      case 1:
      case 2:
      case 3:
        month += 9
        year--
        break
      default:
        month -= 3
        break
    }
  }
  let d = new Date(year, month, 0);
  let lastDay = d.getDate();
  if (date > lastDay) {
    date = lastDay
  }
  month = (month < 10) ? ('0' + month) : month
  date = (date < 10) ? ('0' + date) : date
  return year + '-' + month + '-' + date
}

// 区分环境对支付方式过滤
export function filterPayMethodList(payMethodList, env, showCMBpay = '', showABCWallet) {
  let wallet = []
  // 华融湘江支付
  if (!config.showJHUNIVERSALPAY) {
    payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('JH_UNIVERSALPAY') === -1)
  }
  // 前台支付
  if (!config.showFRONTPAYMENT || (config.showFRONTPAYMENT && env !== 'wxMini')) {
    payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('FRONT_PAYMENT') === -1)
  }
  if (!config.showCZYPAY) {
    payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('CZY_PAY') === -1)
  }
  
  if (showCMBpay !== 'true') {
    payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('CMBPAY') === -1)
  }
  // 过滤展示华为钱包支付

  if (!(config.showHuaWeipay === 'true' && navigator.userAgent.toLowerCase().match(/huawei/i) == 'huawei' && !navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1)) {
    payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('HUAWEIPAY') === -1)
  }
  const ABC_WALLET_PAY = payMethodList.filter(item => item.paymentMethodId.indexOf('ABC_WALLET_PAY') != -1)
  if (showABCWallet && ABC_WALLET_PAY.length > 0) {
    const item = ABC_WALLET_PAY[0]
    wallet.push({
      ...item,
      remark: item.paySubMethodList[0].remark,
      remarkColor: item.paySubMethodList[0].remarkColor
    })
  }
  const CITIC_WALLET_PAY = payMethodList.filter(item => item.paymentMethodId.indexOf('CITIC_WALLET') != -1)
  if (config.showCITICWallet && CITIC_WALLET_PAY.length > 0) {
    const item = CITIC_WALLET_PAY[0]
    wallet.push({
      ...item,
      remark: item.paySubMethodList[0].remark,
      remarkColor: item.paySubMethodList[0].remarkColor
    })
  }
  
  // 浦发
  const SPDB_WALLET_PAY = payMethodList.filter(item => item.paymentMethodId.indexOf('SPDB_WALLET') != -1)
  if (config.showSPDBWallet && SPDB_WALLET_PAY.length > 0) {
    const item = SPDB_WALLET_PAY[0]
    wallet.push({
      ...item,
      remark: item.paySubMethodList[0].remark,
      remarkColor: item.paySubMethodList[0].remarkColor
    })
  }
  // 新钱包支付
  const FZS_WALLET_PAY = payMethodList.filter(item => item.paymentMethodId.includes('FZS_WALLET'))
  if (config.showFzsWalletPay && FZS_WALLET_PAY.length > 0) {
    FZS_WALLET_PAY[0].paySubMethodList.forEach((val)=>{
      if((config.showFzsWalletPayCCB && val.paymentSubMethodId.includes('FZS_WALLET_CCB')) || (config.showFzsWalletPayCITIC && val.paymentSubMethodId.includes('FZS_WALLET_CITIC')) || (config.showFzsWalletPayABC && val.paymentSubMethodId.includes('FZS_WALLET_ABC')) || (config.showFzsWalletPaySPDB && val.paymentSubMethodId.includes('FZS_WALLET_SPDB'))){ // 展示建行新钱包支付
        wallet.push({
          paymentMethodId: FZS_WALLET_PAY[0].paymentMethodId,
          payIcon: val.paymentSubMethodId,
          paymentMethodName: val.paymentSubMethodName,
          paySubMethodList: [val],
          remark: val.remark,
          remarkColor: val.remarkColor
        })
      } 
    })
  }
  // 过滤展示新钱包支付
  payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('FZS_WALLET') === -1)

  // 过滤展示农行钱包支付
  payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('ABC_WALLET_PAY') === -1)
  // 过滤展示中信钱包支付
  payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('CITIC_WALLET') === -1)
  payMethodList = payMethodList.filter(item => item.paymentMethodId.indexOf('SPDB_WALLET') === -1)
  let firstPayItem = []
  let sendPayItem = []
  payMethodList.forEach(item => {
    if (item.paySubMethodList && item.paySubMethodList.length) {
      let { paymentMethodId, paySubMethodList } = item
      // 优先处理扫码支付 paySubMethodList只有一个
      if (paymentMethodId.indexOf('CBCPAY') !== -1 && config.cbcPaySubCode) {
        paySubMethodList.forEach((val) => {
          if (val.paymentSubMethodId === config.cbcPaySubCode) {
            item.remark = val.remark
            item.remarkColor = val.remarkColor
          }
        })
      } else if (paymentMethodId.indexOf('CMBPAY') !== -1) {
        item.remark = config.cmbPayDesc
        item.remarkColor = ''
      } else if (paymentMethodId.indexOf('ABCPAY') !== -1) {
        item.remark = paySubMethodList[0].remark
        item.remarkColor = paySubMethodList[0].remarkColor
      } else if (paymentMethodId.indexOf('JH_UNIVERSALPAY') !== -1) {
        const sub = paySubMethodList.filter(item => item.paymentSubMethodId.indexOf(config.JHUNIVERSALPAYSubCode) > -1)
        item.paySubMethodList = sub
        item.remark = sub[0].remark
        item.remarkColor = sub[0].remarkColor
      } else {
        item.remark = paySubMethodList[0].remark
        item.remarkColor = paySubMethodList[0].remarkColor
      }
      item.paySubMethodList.forEach((subItem) => {
        if (subItem.paymentMethodLogo) {
          item.paymentMethodLogo = subItem.paymentMethodLogo
        }
      })
      if (paymentMethodId === 'HUAWEIPAY') {
        firstPayItem.push(item)
      } else {
        sendPayItem.push(item)
      }
    }
  })
  payMethodList = [...firstPayItem, ...sendPayItem]
  payMethodList = [...payMethodList, ...wallet]
  const payType = getSessionCache('payType')
  if (payType === 'hbPay') { // 花呗支付归属于支付宝，过滤掉出支付宝之外的数据
    payMethodList = payMethodList.filter(payItem => payItem.paymentMethodId === 'ALIPAY')
  }
  if (isInWechat()) {
    return payMethodList.filter(item => item.paymentMethodId.indexOf('ALIPAY') === -1)
  } else if (isInAlipay()) {
    return payMethodList.filter(item => item.paymentMethodId.indexOf('WX') === -1)
  } else {
    return payMethodList
  }
}

// 获取缓存的用户信息
export function getCacheUserInfo() {
  // 缓存的用户信息
  let cacheUser = getStorageCache('cacheUser')
  // 缓存的邀请码
  let inviteCode = getUrlParam('invitecode') || getSessionCache('invitecode')
  let cyAuthToken = getUrlParam('cyAuthToken') || getSessionCache('cyAuthToken')
  let cyAuthType = getUrlParam('cyAuthType') || getSessionCache('cyAuthType')
  let cyUserId = getUrlParam('cyUserId') || getSessionCache('cyUserId')
  /**
   * @desc 更新用户信息
   */
  let data = {}
  if (inviteCode) {
    setSessionCache('invitecode', inviteCode)
    data.inviteCode = inviteCode
  } else {
    setSessionCache('invitecode', '')
    data.inviteCode = ''
  }
  if (cyAuthToken) {
    setSessionCache('cyAuthToken', cyAuthToken)
    data.cyAuthToken = cyAuthToken
  } else {
    setSessionCache('cyAuthToken', '')
    data.cyAuthToken = ''
  }
  if (cyAuthType) {
    setSessionCache('cyAuthType', cyAuthType)
    data.cyAuthType = cyAuthType
  } else {
    setSessionCache('cyAuthType', '')
    data.cyAuthType = ''
  }
  if (cyUserId) {
    setSessionCache('cyUserId', cyUserId)
    data.cyUserId = cyUserId
  } else {
    setSessionCache('cyUserId', '')
    data.cyUserId = ''
  }

  let unionId = getUrlParam('unionId') || getSessionCache('unionId')
  let appId = getUrlParam('appId') || getSessionCache('appId')
  let openId = getUrlParam('openId') || getSessionCache('openId')
  if (unionId) {
    setSessionCache('unionId', unionId)
    data.unionId = unionId
  } else {
    data.unionId = ''
  }
  if (appId) {
    setSessionCache('appId', appId)
    data.appId = appId
  } else {
    data.appId = ''
  }
  if (openId) {
    setSessionCache('openId', openId)
    data.openId = openId
  } else {
    data.openId = ''
  }
  if (cacheUser) {
    data = { ...cacheUser, ...data }
  }

  return data
}

const payMethodList = [
  {
    'paymentMethodId': 'WXPAY',
    'paymentMethodName': '微信'
  }, {
    'paymentMethodId': 'ALIPAY',
    'paymentMethodName': '支付宝'
  }, {
    'paymentMethodId': 'UMPAY',
    'paymentMethodName': '银联'
  }, {
    'paymentMethodId': 'UMPOSPAY',
    'paymentMethodName': '银联商务POS机'
  }, {
    'paymentMethodId': 'WXMPPAY',
    'paymentMethodName': '微信公众号'
  }, {
    'paymentMethodId': 'CBCPAY',
    'paymentMethodName': '建行支付'
  }, {
    'paymentMethodId': 'HEBAO_PAY',
    'paymentMethodName': '和包支付'
  }, {
    'paymentMethodId': 'CZY_PAY',
    'paymentMethodName': '彩之云支付'
  }, {
    'paymentMethodId': 'CBCPAY_FJ',
    'paymentMethodName': '福建建行龙支付'
  }, {
    'paymentMethodId': 'WXPAY_SCAN',
    'paymentMethodName': '微信扫码'
  }, {
    'paymentMethodId': 'ALIPAY_SCAN',
    'paymentMethodName': '支付宝扫码'
  }, {
    'paymentMethodId': 'ALIPAY_HB',
    'paymentMethodName': '花呗分期'
  }, {
    'paymentMethodId': 'GOLD_PAY',
    'paymentMethodName': '金币支付'
  }, {
    'paymentMethodId': 'CCBPAY_SCAN',
    'paymentMethodName': '建行扫码支付'
  }, {
    'paymentMethodId': 'BOCPAY',
    'paymentMethodName': '中国银行支付'
  }, {
    'paymentMethodId': 'ABCPAY',
    'paymentMethodName': '农业银行支付'
  }, {
    'paymentMethodId': 'CITIC_WALLET',
    'paymentMethodName': '中信银行支付'
  }, {
    'paymentMethodId': 'SPDB_WALLET',
    'paymentMethodName': '浦发银行支付'
  }
]

export function getPayMethodName(id) {
  let txt = id
  payMethodList.forEach(val => {
    if (val.paymentMethodId === id) {
      txt = val.paymentMethodName
    }
  })
  return txt
}

export function processExpressCode(name) {
  let expressCompanyName = ''
  switch (name) {
    case '顺丰快递':
      expressCompanyName = 'shunfeng'
      break
    case '申通快递':
      expressCompanyName = 'shentong'
      break
    case '中通快递':
      expressCompanyName = 'zhongtong'
      break
    case '京东快递':
      expressCompanyName = 'jd'
      break
    case '圆通速递':
      expressCompanyName = 'yuantong'
      break
    case '韵达快递':
      expressCompanyName = 'yunda'
      break
    case '百世快递':
      expressCompanyName = 'huitongkuaidi'
      break
    case '天天快递':
      expressCompanyName = 'tiantian'
      break
    case '邮政快递':
      expressCompanyName = 'youzhengguonei'
      break
    case 'EMS':
      expressCompanyName = 'ems'
      break
    case '宅急送':
      expressCompanyName = 'zhaijisong'
      break
    case '德邦物流':
      expressCompanyName = 'debangwuliu'
      break
    case '全峰全球专递':
      expressCompanyName = 'quanfengkuaidi'
      break
  }
  return expressCompanyName
}

/**
 * @description debounce
 * @param {Function} fn
 * @param {Number} delay
 */
export function debounce(fn, delay) {
  let timer
  return function delayFn() {
    const context = this,
      args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(context, args)
    }, delay)
  }
}
